/**
 * GameSpeechBubble Component
 * 
 * Speech bubble for Squiggle that can contain text or inline forms.
 * Designed to work inline with the content, not as a floating overlay.
 */

import React from 'react';
import { motion } from 'framer-motion';
import styles from './GameSpeechBubble.module.scss';

export type BubbleTailDirection = 'left' | 'right' | 'bottom' | 'top';

interface GameSpeechBubbleProps {
  children: React.ReactNode;
  tailDirection?: BubbleTailDirection;
  className?: string;
  animate?: boolean;
}

export const GameSpeechBubble: React.FC<GameSpeechBubbleProps> = ({
  children,
  tailDirection = 'left',
  className = '',
  animate = true,
}) => {
  const animationProps = animate
    ? {
        initial: { opacity: 0, scale: 0.9 },
        animate: { opacity: 1, scale: 1 },
        transition: {
          type: 'spring' as const,
          stiffness: 400,
          damping: 25,
        },
      }
    : {};

  return (
    <motion.div
      className={`${styles.bubble} ${styles[`tail-${tailDirection}`]} ${className}`}
      {...animationProps}
    >
      <div className={styles.content}>
        {children}
      </div>
    </motion.div>
  );
};

export default GameSpeechBubble;
